// @ts-check
import axios from 'axios';
import q from 'q';
// import qs from 'qs'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.withCredentials = true;
// axios.defaults.headers.post['withCredentials'] = 'true'

class BaseRequest {
    // constructor () {}

    send ({ url, type = 'get', timeout = 10000, headers = {} }, body = {}) {
        let options = {
            url: url,
            method: type.toLocaleLowerCase(),
            timeout: timeout,
            headers: headers
            // withCredentials: true
        };

        try {
            // 处理 post 参数格式
            if (options.method === 'post') {
                // qs将请求数据转换为form-data格式
                // options.data = qs.stringify(body)
                // 请求数据json格式
                options.data = body;
            } else if (options.method === 'get') {
                options.params = body;
            } else {
                options.data = body;
            }
            return q.resolve(axios(options));
        } catch (e) {
            q.reject(e);
        }
    }
}

export default BaseRequest;



// WEBPACK FOOTER //
// ./src/core/BaseRequest.js